import { Link } from "react-router-dom"
import { Button } from "../components/ui/button"
import { Card, CardContent } from "../components/ui/card"
import { Home, Search, ArrowLeft } from "lucide-react"

function NotFoundPage() {
    return (
        <div className="min-h-screen flex items-center justify-center bg-background p-4">
            <Card className="w-full max-w-2xl">
                <CardContent className="pt-8 pb-8">
                    <div className="text-center space-y-6">
                        {/* 404 Illustration */}
                        <div className="flex justify-center">
                            <div className="relative">
                                <div className="text-9xl font-bold text-primary/10">404</div>
                                <div className="absolute inset-0 flex items-center justify-center">
                                    <Search className="h-16 w-16 text-primary/40" />
                                </div>
                            </div>
                        </div>

                        {/* Error Message */}
                        <div className="space-y-2">
                            <h1 className="text-3xl font-bold tracking-tight">Page Not Found</h1>
                            <p className="text-lg text-muted-foreground">
                                Oops! The page you're looking for doesn't exist.
                            </p>
                            <p className="text-sm text-muted-foreground">
                                It might have been moved or deleted, or you may have typed the wrong URL.
                            </p>
                        </div>

                        {/* Action Buttons */}
                        <div className="flex flex-col sm:flex-row gap-4 justify-center pt-4">
                            <Button asChild size="lg" className="gap-2">
                                <Link to="/">
                                    <Home className="h-4 w-4" />
                                    Go to Home
                                </Link>
                            </Button>
                            <Button asChild variant="outline" size="lg" className="gap-2">
                                <Link to="/dashboard">
                                    <ArrowLeft className="h-4 w-4" />
                                    Back to Dashboard
                                </Link>
                            </Button>
                        </div>

                        {/* Helpful Links */}
                        <div className="pt-6 border-t">
                            <p className="text-sm text-muted-foreground mb-3">You might be looking for:</p>
                            <div className="flex flex-wrap gap-2 justify-center">
                                <Link to="/store" className="text-sm text-primary hover:underline">Store</Link>
                                <span className="text-muted-foreground">•</span>
                                <Link to="/contributions" className="text-sm text-primary hover:underline">Contributions</Link>
                                <span className="text-muted-foreground">•</span>
                                <Link to="/resources" className="text-sm text-primary hover:underline">Learning Resources</Link>
                            </div>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
}

export {
    NotFoundPage,
}